import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled } from "@mui/material/styles";

const fadeInOutAnimation = {
  "0%": {
    opacity: 0,
  },
  "50%": {
    opacity: 1,
  },
  "100%": {
    opacity: 0,
  },
};

const SidePanelContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "0px 40px",
  height: "70%",
  width: "100%",
  position: "relative",
  overflowY: "auto",

  scrollbarWidth: "revert-layer",
  "&::-webkit-scrollbar": {
    width: "8px", // Adjust as needed
    height: "8px", // Adjust as needed
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "gray",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    display: "none",
  },
  "&::-webkit-scrollbar-button": {
    display: "none",
  },

  // Apply animation
  animation: `${fadeInOutAnimation} 1.5s infinite`,
});

const RightArrowIconButton = styled(ChevronRightIcon)({
  color: "white",
  position: "relative",
  alignSelf: "flex-end",
  marginTop: "70px",
  marginBottom: "15px",
  top: "50px",
  right: "470px",
  cursor: "pointer",
  zIndex: 1000,
  backgroundColor: "gray",
  fontSize: "2rem",
  transition: "transform 0.3s",
  "&:hover": {
    backgroundColor: "rgba(169, 169, 169, 0.7)",
    transform: "scale(1.1, 1.1)",
  },
});

const ThumbnailScroller = styled("div")({
  display: "flex",
  overflowX: "auto",
  gap: "10px",
  marginTop: "20px",
  paddingBottom: "10px",
  width: "100%",
});

const Thumbnail = styled("img")(({ isActive }) => ({
  width: 100,
  height: 80,
  objectFit: "cover",
  borderRadius: "4px",
  border: isActive ? "3px solid #3f51b5" : "2px solid #ccc",
  cursor: "pointer",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const MainImage = styled("img")({
  width: "100%",
  maxHeight: "50vh",
  objectFit: "contain",
  borderRadius: "10px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
});

const ImagesSidePanel = ({ isOpen, onClose, ssuidDetail = [] }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setCurrentImageIndex(0); // Reset when panel opens
    }
  }, [isOpen]);

  function formatDateTime(isoDateStr) {
    const dateObj = new Date(isoDateStr);

    // Format date as YYYY-MM-DD
    const datePart = dateObj.toISOString().split("T")[0];

    // Format time as h:mm AM/PM
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHour = hours % 12 || 12; // Convert 0 -> 12 for 12 AM
    const timePart = `${formattedHour}:${minutes} ${ampm}`;

    return {
      date: datePart,
      time: timePart,
    };
  }

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <div className="empty-div"></div>
      <Divider />
      <RightArrowIconButton onClick={onClose} />
      <SidePanelContainer style={{ width: 500 }}>
        {ssuidDetail.length > 0 ? (
          <>
            <MainImage
              src={ssuidDetail[currentImageIndex].src}
              alt={`Image ${currentImageIndex + 1}`}
            />

            <ThumbnailScroller>
              {ssuidDetail.map((data, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: 100,
                    height: 100,
                  }}
                >
                  <Thumbnail
                    src={data.src}
                    alt={`Thumbnail ${index + 1}`}
                    isActive={index === currentImageIndex}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                  <span
                    style={{
                      textAlign: "center",
                      fontSize: "0.7rem",
                      marginTop: "5px",
                    }}
                  >
                    {formatDateTime(data.createdAt).date}
                  </span>
                  <span
                    style={{
                      textAlign: "center",
                      fontSize: "0.7rem",
                      marginTop: "5px",
                    }}
                  >
                    {formatDateTime(data.createdAt).time}
                  </span>
                </div>
              ))}
            </ThumbnailScroller>
          </>
        ) : (
          <div>No images available</div>
        )}
      </SidePanelContainer>
    </Drawer>
  );
};

export default ImagesSidePanel;
